import { render, staticRenderFns } from "./age-confirm.vue?vue&type=template&id=198c6a40&scoped=true"
import script from "./age-confirm.vue?vue&type=script&lang=js"
export * from "./age-confirm.vue?vue&type=script&lang=js"
import style0 from "./age-confirm.vue?vue&type=style&index=0&id=198c6a40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198c6a40",
  null
  
)

export default component.exports